import router from './router'
import store from './store'
import Cookies from 'js-cookie'
import { addQueryToUrl } from '@/utils/utils'

router.beforeEach(async(to, from, next) => {
  const ac = Cookies.get('X-JCZH-AC') || ''

  try {
    // 若用户处于非登录状态，则向后台验证登录态
    if (!store.state.user.isLogin) {
      await store.dispatch('user/checkLoginState')
    }

    const loginIdentity = store.state.user.loginIdentity

    // 如果携带returnUrl，且前往登录页面则返回returnUrl
    const search = window.location.search.replace('?', '')
    let returnUrl = ''
    search.split('&').forEach(value => {
      const temp = value.split('=')
      if (temp[0] === 'returnUrl') {
        returnUrl = decodeURIComponent(temp[1])
      }
    })

    if (returnUrl && to.name === 'Login' && ac) {
      window.location.href = addQueryToUrl(returnUrl, { ac: ac })
      return
    }

    // 登录状态下，若访问的是私有或完全公开的页面则直接跳转；否则进行判断跳转
    if (to.meta.pageType === 'public') {
      return next()
    }

    if (to.meta.pageType === 'protected') {
      if (loginIdentity.includes('purchase')) {
        // 登录状态下，访问公开页面，当登录了采购工作台则导航至采购工作台
        window.location.href = addQueryToUrl(
          process.env.VUE_APP_LOGIN_JUMP_URL,
          { ac: ac }
        )
      } else if (loginIdentity.includes('expert')) {
        // 登录状态下，访问公开页面，当登录了专家工作台则导航至专家工作台
        window.location.href = addQueryToUrl(process.env.VUE_APP_EXPERT_URL, {
          ac: ac
        })
      } else if (!loginIdentity.length && store.state.user.isLogin) {
        // 预登录状态下，访问公开页面，导航至选择企业页
        window.location.href = addQueryToUrl(
          process.env.VUE_APP_LOGIN_JUMP_URL,
          { ac: ac }
        )
      } else {
        return next()
      }
    }

    // 以下默认为私有页面
    if (loginIdentity.includes('purchase')) {
      if (!store.state.user.userId) {
        try {
          await Promise.all([
            store.dispatch('user/getUserInfo'),
            store.dispatch('user/getEmployeeInfo'),
            store.dispatch('company/getUserCompanyInfo'),
            store.dispatch('user/getJoinedCompany')
          ])
        } catch (e) {
          throw Error('获取用户信息失败')
        }
      }

      return next()
    } else {
      try {
        await Promise.all([store.dispatch('user/getUserInfo')])
      } catch (e) {
        throw Error('获取用户信息失败')
      }
    }

    next()
  } catch (e) {
    // 若访问的不是私有页面则直接跳转，否则重定向到登录页面
    // pageType为undefined时，相当于private。路由定义：pageType不定义时，默认为private
    if (to.meta.pageType && to.meta.pageType !== 'private') {
      next()
    } else {
      next({ name: 'Login' })
    }
  }
})
